import { useIO, useLinked, useModel } from "@type-r/react";
import { Loading } from "lqx-react";
import React from "react";
import { AssetType } from "../../api/assetType";
import { Company } from "../../api/company";
import { DocumentSource } from "../../api/documentSource";
import { IngestionJob } from "../../api/ingestionJob";
import { ImportTemplatesLookup } from "../../api/lookups";
import { AddAssetsStep } from "../add-assets-step";

export const AddMultiAssetsStep = ({ next, back, cancel, job }:
    { next?, back?, cancel?, job: IngestionJob }) => {
    const assetExtensions = "*.xlsx,*.xls,*.csv";
    const userTemplates = useModel(ImportTemplatesLookup);
    const $allowedExtension = useLinked(assetExtensions);
    const $dataHolderId = useLinked<Company>(new Company());
    const showDownloadTemplate = false;
    const showAssetTypes = true;
    const $userTemplate = useLinked<{ id?: string }>(null)
        .onChange(x => applyImportTemplateExtension(x.id));

    const applyImportTemplateExtension = (userTemplateId) => {
        if (Boolean(userTemplateId) && Boolean(userTemplates)) {
            let importTemplateExtension = userTemplates.items.find((item) => item.id === userTemplateId).originalFileName.split(".").pop();
            $allowedExtension.set(`*.${importTemplateExtension}`);
        } else {
            $allowedExtension.set(assetExtensions);
        }
    }

    const isReady = useIO(async () => {
        const params = { params: { assetTypeId: AssetType.multiAsset } }
        await userTemplates.fetch(params).catch(e => console.error(e));
    }, []);

    return isReady ?
        <>
            <AddAssetsStep
                assetName="Multiple Assets"
                allowedExtension={$allowedExtension.value}
                // MultipleAsset sourceId hardcoded as Invoice, need to be changed accroding to dource type
                jobInfoProvider={() => ({ ...DocumentSource.MultipleAsset, userTemplateId: $userTemplate.value.id, dataHolderId: Boolean($dataHolderId.value) ? $dataHolderId.value.id : null })}
                $dataHolderId={$dataHolderId}
                userTemplates={userTemplates}
                $userTemplate={$userTemplate}
                showDownloadTemplate={showDownloadTemplate}
                showAssetTypes={showAssetTypes}
                next={next} back={back} cancel={cancel} job={job} />
        </> : <Loading />
};